import React from 'react';
import { bool, func, instanceOf, object, string } from 'prop-types';

import styled from 'styled-components/macro';
import { MdEvent } from 'react-icons/md';

import Flatpickr from 'react-flatpickr';
import ConfirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate';
import 'flatpickr/dist/themes/airbnb.css'; // Theme over-rides in `global-styles`

import { baseSpacing, colors, radius } from 'css/constants';

const Wrapper = styled.div`
  position: relative;

  & > div {
    width: 100%;
  }
`;

const StyledFlatpickr = styled(Flatpickr)`
  width: 100%;
  padding: ${baseSpacing / 8}px ${baseSpacing / 2}px ${baseSpacing / 8}px
    ${baseSpacing * 1.5}px;
  background-color: hsl(0deg 0% 98%);
  border-color: hsl(0deg 0% 80%);
  border-radius: ${radius}px;
  border-style: solid;
  border-width: 1px;
  min-height: 38px;

  &:disabled {
    background-color: ${colors.lightGrey};
    text-shadow: 1px 1px rgb(255 255 255 / 20%);
    cursor: not-allowed;
  }
`;

const Icon = styled(MdEvent)`
  position: absolute;
  top: 50%;
  left: ${baseSpacing / 2}px;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 1.5rem;
  color: ${colors.midGrey};
`;

const DatePicker = ({
  className,
  disabled,
  onChange,
  name,
  options,
  placeholder,
  value
}) => {
  // When selected date changes, let formik know which field to update
  const handleChange = (selectedDates) => {
    onChange(name, selectedDates[0]);
  };

  return (
    <Wrapper className={className}>
      <StyledFlatpickr
        disabled={disabled}
        options={{
          animate: false,
          allowInput: false,
          dateFormat: 'j M Y h:i K',
          enableTime: true,
          defaultHour: 0,
          defaultMinute: 0,
          minuteIncrement: 1,
          position: 'above',
          static: false,
          plugins: [
            new ConfirmDatePlugin({
              confirmText: 'Ok'
            })
          ],
          ...options
        }}
        onValueUpdate={handleChange}
        placeholder={placeholder}
        value={value}
      />
      <Icon />
    </Wrapper>
  );
};

DatePicker.propTypes = {
  className: string,
  disabled: bool,
  name: string.isRequired,
  options: object,
  onChange: func.isRequired,
  placeholder: string,
  value: instanceOf(Date)
};

DatePicker.defaultProps = {
  placeholder: 'Select date'
};

export default DatePicker;
